// import { NotImplementedError } from '../../../common/errors'
// import { DEFAULT_TIMEZONE_INTERVAL, Options, Query } from '../../Query'

import type { DateTimeFilterExpressionType } from '../../../../../schemas/misc/timeframe.ts'
import type { AlwaysFilter, FilterType } from '../../../../../schemas/query/filterTypes.ts'
import type { FieldType } from '../../../../../schemas/query/index.ts'
import { NotImplementedError, ValidationError } from '../../../../errors.ts'
import type { CompileContext } from '../../../common.ts'
import { generateArrayFilter } from './generateFilterSql/generateArrayFilter.ts'
import { generateBooleanFilter } from './generateFilterSql/generateBooleanFilter.ts'
import { generateDateFilter } from './generateFilterSql/generateDateFilter.ts'
import { generateNumericFilter } from './generateFilterSql/generateNumericFilter.ts'
import { generateStringFilter } from './generateFilterSql/generateStringFilter.ts'
import { generateTimeFilter } from './generateFilterSql/generateTimeFilter.ts'

export const generateFilterSql = ({
  fieldSql,
  fieldType,
  filterType,
  filterValue,
  dateTimeType,
  context,
  shouldConsiderCase,
}: {
  fieldSql: string
  fieldType: FieldType
  filterType: FilterType
  filterValue: unknown
  dateTimeType: DateTimeFilterExpressionType | undefined
  context: CompileContext
  // 現状propertyFilterのみで使用
  shouldConsiderCase?: boolean
}): string | undefined => {
  // eslint-disable-next-line sonarjs/todo-tag
  // TODO: いったんalwaysFilterに揃えている
  const filter: AlwaysFilter = {
    field_name: fieldSql,
    field_type: fieldType,
    filter_type: filterType,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    filter_expression: filterValue as string | number | undefined,
  }

  try {
    switch (fieldType) {
      case 'string': {
        return generateStringFilter(filter, shouldConsiderCase)
      }
      case 'integer': {
        return generateNumericFilter(filter)
      }
      case 'numeric': {
        return generateNumericFilter(filter)
      }
      case 'date': {
        return generateDateFilter(filter, undefined, dateTimeType, context)
      }
      case 'datetime': {
        return generateDateFilter(filter, undefined, dateTimeType, context)
      }
      case 'time': {
        return generateTimeFilter(filter, undefined)
      }
      case 'boolean': {
        return generateBooleanFilter(filter)
      }
      case 'array': {
        return generateArrayFilter(filter)
      }
      case 'object': {
        throw new NotImplementedError(`not implemented filter: ${filter.field_type}`)
      }
      // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
      default: {
        // eslint-disable-next-line sonarjs/todo-tag
        // const x: never = filter.field_type // TODO
        return generateBooleanFilter(filter)
      }
    }
  } catch (error: unknown) {
    if (error instanceof ValidationError) {
      // notifyBugsnag({ error: e })

      return undefined
    }
    throw error
  }
}
